/**
 * @file  : index.js
 * @author: Tamnil Saito Junior <tamnil@gmail.com>
 * Date   : 23.03.2020
 */
"use strict";




Vue.config.devtools = true;

const baseUrl = "/wp-json/macfor/v1";

const getAllPages = (catId = 6) => axios.get(`${baseUrl}/especialidades?id=${catId}`);
const getCategories = (catId = 6) => axios.get(`${baseUrl}/especialidades?id=${catId}`);
// const getCategories = () => axios.get(`${baseUrl}/especialidades/categories`);

var especialidades = new Vue({
  el: "#especialidades-reactive-section",
  components: {
    menuCategories: require("./components/menu-categories.vue").default,
    // mainbody: require("./components/body.vue").default
  },
  data: {
    sitedata: "not",
    postData: [],
    categories: [],
    activeCategory: "10"
  },
  async mounted() {
    let siteData = await Promise.all([getAllPages(), getCategories()]);

	  console.log(siteData)

    this.postData = siteData[0].data;
    this.categories = siteData[1].data;
  },
  methods: {
    hello: () => {},
    async onChangeCategory(value) {
      this.activeCategory = value;
      let cat = await getAllPages(value);
      this.postData = cat.data;
    }
  },

  template: `<div>

  hello
		<menu-categories :categories=categories @changeCategory=onChangeCategory />  
		<mainbody :posts=postData  /> 
	</div>`
});
